import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { closeBrowserSession } from '../actions';

export const useCloseBrowserApi = (consentGuid) => {
  const userToken = useSelector((state) =>
    state.currentLogin?.user_token || state.sessionData?.user_token
  );

  useEffect(() => {
    const handlePageHide = () => {
      closeBrowserSession(consentGuid, userToken).catch(() => {});
    };

    window.addEventListener('pagehide', handlePageHide);
    return () => window.removeEventListener('pagehide', handlePageHide);
  }, [consentGuid, userToken]);
};